import React, { CSSProperties, type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import {
  Button,
  colors,
  fontSize,
  Label,
  spacing,
  Text,
} from '@retailer-platform/shared-components'
import { type Styles } from 'react-select'

export const InsightsPortalDashboardContainer = styled.div({
  backgroundColor: colors.GRAYSCALE.X10,
})

export const FiltersButton = styled(Button)({
  borderRadius: '6px',
  display: 'flex',
  backgroundColor: colors.GRAYSCALE.X0,
  border: '1px solid #C7C8CD',
  alignItems: 'center',
})

export const ViewByText = styled.div({
  alignSelf: 'center',
  whiteSpace: 'nowrap',
  color: colors.GRAYSCALE.X50,
  fontSize: spacing.X12,
  padding: `0 ${spacing.X12}`,
  fontWeight: 600,
})

export const InsightsPortalLayout = styled.div({
  display: 'grid',
  gridTemplateColumns: '300px calc(100% - 300px)',
  height: '100%',
  width: '100%',
})

export const InsightsPortalFilterSectionContainer = styled.div({
  grid: '1/1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  borderRight: '2px solid',
  borderColor: colors.GRAYSCALE.X20,
})

export const InsightsPortalMainSectionContainer = styled.div({
  marginLeft: spacing.X8,
  marginRight: spacing.X8,
})

export const InsightsPortalMetricsContainer = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',

  gridGap: '1px',
  backgroundColor: colors.GRAYSCALE.X20,
  borderTop: `1px solid ${colors.GRAYSCALE.X20}`,
  borderBottom: `1px solid ${colors.GRAYSCALE.X20}`,
})
export const InsightsPortalMetricContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  padding: spacing.X16,
  backgroundColor: colors.GRAYSCALE.X0,
})

export const InsightsPortalWidgetContainer = styled.div({
  width: '100%',
  paddingLeft: 21,
  paddingRight: 21,
  paddingBottom: 21,
})

export const InsightsPortalWidgetCard = styled.div({
  borderRadius: spacing.X12,
  border: `1px solid ${colors.GRAYSCALE.X20}`,
  padding: '22px 14px',
  backgroundColor: colors.GRAYSCALE.X0,
})

export const InsightsPortalWidgetCardWithTitle: FunctionComponent<{
  title?: string | React.ReactNode
  renderedTitle?: React.ReactNode
  className?: string
}> = ({ children, title, renderedTitle, ...rest }) => (
  <InsightsPortalWidgetCard css={{ padding: 0 }} {...rest}>
    {(title || renderedTitle) && (
      <Text
        weight="bold"
        size="large"
        css={{ margin: 0, padding: '16px 24px', borderBottom: `1px solid ${colors.GRAYSCALE.X20}` }}
      >
        {title || renderedTitle}
      </Text>
    )}

    <div css={{ padding: '22px 24px' }}>{children}</div>
  </InsightsPortalWidgetCard>
)

export const InsightsPortalSectionLayout: FunctionComponent<{
  title?: string
  renderedTitle?: React.ReactNode
}> = ({ children, title, renderedTitle }) => (
  <InsightsPortalWidgetContainer>
    <InsightsPortalWidgetCardWithTitle title={title} renderedTitle={renderedTitle}>
      {children}
    </InsightsPortalWidgetCardWithTitle>
  </InsightsPortalWidgetContainer>
)

export const InsightsPortalDropdownLabel = styled(Label)({
  color: colors.GRAYSCALE.X50,
  fontSize: fontSize.X15,
  fontWeight: 600,
  paddingRight: spacing.X8,
  marginLeft: spacing.X4,
  marginTop: spacing.X8,
  marginBottom: spacing.X8,
})

export const insightsPortalDropdownStyles: Styles = {
  control: () => ({
    background: colors.GRAYSCALE.X10,
    padding: '4px 0px',
  }),
  singleValue: () => ({
    fontSize: fontSize.X15,
    color: colors.GRAYSCALE.X70,
    fontWeight: 600,
    lineHeight: '22px',
  }),
  multiValue: () => ({
    fontSize: fontSize.X15,
    color: colors.GRAYSCALE.X70,
    fontWeight: 600,
    lineHeight: '22px',
    background: colors.GRAYSCALE.X20,
  }),
  option: () => ({
    fontSize: fontSize.X15,
    fontWeight: 600,
    lineHeight: '22px',
    padding: '20px 10px',
    display: 'flex',
    alignItems: 'center',
  }),
}
